const ENT = { amp: "&", lt: "<", gt: ">", quot: '"', apos: "'" };
const decode = (s) => s.replace(/&(amp|lt|gt|quot|apos);/g, (_, e) => ENT[e]).trim();
const SLICE = 8 * 1024 * 1024;

// Reads an .enex in the browser and returns the tag list of every note — nothing is uploaded.
export async function scanEnex(file, onPct) {
  const noteTags = [];
  const decoder = new TextDecoder();
  let carry = "";
  for (let off = 0; off < file.size; off += SLICE) {
    const buf = await file.slice(off, off + SLICE).arrayBuffer();
    const parts = (carry + decoder.decode(buf, { stream: off + SLICE < file.size })).split("</note>");
    carry = parts.pop();
    for (const p of parts) {
      noteTags.push([...new Set([...p.matchAll(/<tag>([^<]*)<\/tag>/g)].map((m) => decode(m[1])).filter(Boolean))]);
    }
    onPct(Math.min(100, Math.round(((off + SLICE) / file.size) * 100)));
  }
  return noteTags;
}

export const notebookName = (f) => f.name.replace(/\.enex$/i, "");
